import { useRef } from "react";
import ReportCustomerDiscountList from "./ReportCustomerDiscountList";

const ReportCustomerDiscountMain = (props) => {
  const listRef = useRef(null);

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <ReportCustomerDiscountList ref={listRef} />
    </div>
  );
};

export default ReportCustomerDiscountMain;
